import { Component } from '@angular/core';
import { MiGarage } from '../../components/garage/mi-garage/mi-garage';
import { MainLayout } from '../../layouts/main-layout';
import { MarginWrapper } from '../../layouts/margin-wrapper';

@Component({
  selector: 'allas-garage',
  imports: [MiGarage, MainLayout, MarginWrapper],
  template: `
    <allas-main-layout>
      <allas-margin-wrapper>
        <allas-mi-garage></allas-mi-garage>
      </allas-margin-wrapper>
    </allas-main-layout>
  `,
})
export class Garage {}
